import { CalendarDays, ScanLine, LayoutDashboard, LineChart } from "lucide-react";

export const APPS = [
  {
    id: "book",
    name: "Book a Meeting",
    short: "Meetings",
    url: "https://calendly.com/arora-sukhvinder-eybconsulting",
    icon: CalendarDays,
    gradient: "from-[#2EC1F0] to-[#1273C4]",
    glow: "rgba(46,193,240,0.55)",
  },
  {
    id: "scan",
    name: "Scan a Document",
    short: "Scanner",
    url: "https://scanner.eybconsulting.com.au",
    icon: ScanLine,
    gradient: "from-[#38D6B5] to-[#0E8FA8]",
    glow: "rgba(56,214,181,0.5)",
  },
  {
    id: "portal",
    name: "Client Portal",
    short: "Portal",
    url: "https://clientportal.eybconsulting.com.au",
    icon: LayoutDashboard,
    gradient: "from-[#6D8BFF] to-[#2A44B8]",
    glow: "rgba(109,139,255,0.5)",
  },
  {
    id: "cashflow",
    name: "Cashflow",
    short: "Cashflow",
    url: "https://cashflow.eybconsulting.com.au/login",
    icon: LineChart,
    gradient: "from-[#3FCB7E] to-[#128A4E]",
    glow: "rgba(63,203,126,0.5)",
  },
];
